import { render, staticRenderFns } from "./m-document-details.vue?vue&type=template&id=f0cf599a&scoped=true&lang=pug"
import script from "./m-document-details.vue?vue&type=script&lang=js"
export * from "./m-document-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0cf599a",
  null
  
)

export default component.exports